/* eslint-disable no-underscore-dangle */
import { apiClient, handleResponse } from './axios';

const formatCourses = (courses) => {
  try {
    const formatedCourses = [];
    for (let i = 0; i < courses.length; i += 1) {
      formatedCourses.push({
        label: `${courses[i].name} Level ${courses[i].level}`,
        value: courses[i]._id,
      });
    }

    return formatedCourses;
  } catch (error) {
    return error.response;
  }
};

async function getFormatedModule() {
  try {
    const response = await apiClient.get('/module');
    const courses = await handleResponse(response);
    return formatCourses(courses);
  } catch (error) {
    return error.response;
  }
}

const getByStudentAndGroup = (userId, groupId) => apiClient.get(`/module/user/${userId}/${groupId}`)
  .then(handleResponse)
  .then((student) => student)
  .catch((error) => Promise.reject(error));

const getTotalProgress = (userId, groupId) => apiClient.get(`/module/totalquiz/${userId}/${groupId}`)
  .then(handleResponse)
  .then((res) => res)
  .catch((error) => Promise.reject(error));

const getTracker = (userId, groupId) => apiClient.get(`unittrackers/user/${userId}/${groupId}`)
  .then(handleResponse)
  .then((res) => res)
  .catch((error) => Promise.reject(error));

const getDetailedResults = (email, units) => apiClient.post(`module/attempts/${email}`, units)
  .then(handleResponse)
  .then((res) => res)
  .catch((error) => Promise.reject(error));

async function getModule() {
  try {
    const response = await apiClient.get('/module/all');
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function addModule(body) {
  try {
    const response = await apiClient.post('/module', body);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function updateModule(id, body) {
  try {
    const response = await apiClient.put(`/module/${id}`, body);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

async function deleteModule(id) {
  try {
    const response = await apiClient.delete(`/module/${id}`);
    const courses = await handleResponse(response);
    return courses;
  } catch (error) {
    return error.response;
  }
}

const getUnits = (moduleId, userId) => apiClient.get(`/module/progress/${moduleId}/${userId}`)
  .then(handleResponse)
  .then((res) => res)
  .catch((error) => Promise.reject(error));

const getIdleTracker = (userId, groupId) => apiClient.get(`idletracker/user/${userId}/${groupId}`)
  .then(handleResponse)
  .then((res) => res)
  .catch((error) => Promise.reject(error));

const getProgressByModule = (moduleId, userId) => apiClient.get(`/module/percentage/${moduleId}/${userId}`)
  .then(handleResponse)
  .then((progress) => progress);

const globalResultsTest = (userId, email, groupId) => apiClient.post(`/module/test/${userId}`, { email, groupId })
  .then(handleResponse)
  .then((units) => units)
  .catch((error) => Promise.reject(error));

const courseServices = {
  getFormatedModule,
  getModule,
  addModule,
  getIdleTracker,
  getUnits,
  getProgressByModule,
  updateModule,
  getTracker,
  getTotalProgress,
  getByStudentAndGroup,
  deleteModule,
  globalResultsTest,
  getDetailedResults,
};

export default courseServices;
